import * as React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { GridToolbar } from "@mui/x-data-grid/internals";

export default function TableCustom(params) {
  return (
    <Box sx={{ height: params.height > 400 ? '80%' : 400, width: "100%" }}>
      <DataGrid
        rows={params.row}
        columns={params.column}
        autosizeOptions={{
          includeHeaders: true,
          includeOutliers: true,
        }}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        density="compact"
        disableColumnSelector
        disableColumnFilter
        disableColumnResize
        disableRowSelectionOnClick
        showToolbar
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: !params.download || true },
            csvOptions: { disableToolbarButton: !params.download || false },
          },
        }}
        sx={{
          ".MuiDataGrid-columnHeaderTitle" :{
            fontWeight:"bold",
            alignSelf:"center"
          },
          ".MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "&.MuiDataGrid-root": {
            border: "none",
          },
        }}
      />
    </Box>
  );
}
